import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AccountStateService } from '@app/core/services/account-state.service';
import { AuthStoreService } from '@app/core/services/auth-store.service';

export const ownerLiveGuard: CanActivateFn = (_route, state) => {
  const authStore = inject(AuthStoreService);
  const accountState = inject(AccountStateService);
  const router = inject(Router);

  if (authStore.role() !== 'owner') {
    return true;
  }

  if (accountState.blockedReasonCode() === 'SubscriptionRequired') {
    return state.url.startsWith('/certifications')
      ? true
      : router.createUrlTree(['/subscription/reactivate']);
  }

  if (accountState.isLive()) {
    return true;
  }

  if (
    accountState.onboardingStatus?.() === 'RegistrationPending' ||
    accountState.blockedReasonCode() === 'RegistrationPendingPayment'
  ) {
    return router.createUrlTree(['/register/pms']);
  }

  return router.createUrlTree(['/owner/blocked'], {
    queryParams: {
      blockedFrom: state.url,
      reason: accountState.blockedReasonCode() || 'Owner account setup is not Live yet.'
    }
  });
};
